"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAllQueryString = exports.getToken = exports.showLoginDialog = void 0;
var WindowApi_1 = require("@/api/browser/WindowApi");
exports.showLoginDialog = function (clientId, lang, resumeState) {
    if (resumeState === void 0) { resumeState = ''; }
    var redir = WindowApi_1.getCurrentDomain() + "/" + lang + "/api/account/externallogincallback/";
    var allstate = {
        url: window.location.href,
        rs: resumeState,
    };
    var kv = [
        ['client_id', clientId],
        ['redirect_uri', redir],
        ['scope', 'email,public_profile'],
        ['response_type', 'token'],
    ];
    var loginUrl = "https://www.facebook.com/v3.1/dialog/oauth?" + kv.map(function (it) { return it[0] + "=" + it[1]; }).join('&');
    loginUrl = loginUrl + "&state=" + encodeURIComponent(JSON.stringify(allstate));
    window.location.href = loginUrl;
};
exports.getToken = function () {
    var href = window.location.href;
    var hrefPcs = href.split('#');
    if (hrefPcs.length < 2)
        return false;
    var tokenQuery = hrefPcs[hrefPcs.length - 1].split('&').filter(function (it) {
        return it.split('=')[0] === 'access_token';
    });
    if (tokenQuery.length) {
        return tokenQuery[0].split('=')[1];
    }
    return '';
};
exports.removeAllQueryString = function () {
    var href = window.location.href;
    var state = '';
    var stateQuery = href.split('?#')[1].split('&').filter(function (it) {
        return it.split('=')[0] === 'state';
    });
    if (stateQuery.length)
        state = stateQuery[0].split('=')[1];
    var noToken = href.split('?#')[0];
    window.history.replaceState(null, null, noToken);
    return state;
};
